import { createClient } from '@supabase/supabase-js'

// Support both Vite (import.meta.env) and Create React App (process.env)
const supabaseUrl = import.meta.env?.VITE_SUPABASE_URL || process.env.REACT_APP_SUPABASE_URL
const supabaseAnonKey = import.meta.env?.VITE_SUPABASE_ANON_KEY || process.env.REACT_APP_SUPABASE_ANON_KEY

// Throw a helpful error if env vars are missing
if (!supabaseUrl || !supabaseAnonKey) {
  console.error('❌ Missing Supabase environment variables!')
  console.error('Make sure you have a .env file with:')
  console.error('  VITE_SUPABASE_URL=your_url (for Vite)')
  console.error('  VITE_SUPABASE_ANON_KEY=your_key (for Vite)')
  console.error('Or for Create React App:')
  console.error('  REACT_APP_SUPABASE_URL=your_url')
  console.error('  REACT_APP_SUPABASE_ANON_KEY=your_key')
  throw new Error('supabaseUrl and supabaseAnonKey are required. Check your .env file.')
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    flowType: 'pkce',
    storage: localStorage,
    persistSession: true,
    detectSessionInUrl: true,  // ✅ CRITICAL: Changed from false to true for OAuth
    autoRefreshToken: true,
  }
})